import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl, defineMessages } from 'react-intl';
import { reduxForm, touch, focus } from 'redux-form';

import * as templateActions from 'modules/templateAttach';
import * as common from 'libs/commonFunc';

import { Message, Icon, Button, List, Label } from 'semantic-ui-react';
import { ModalTemplate, Loading, Button as Btn, ReduxFormMaterialTextField } from 'components';

class ExamAttachCopyModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      errorMessage: '',
    }
  }

  onInitErrorMessage = () => {
    this.setState({ errorMessage: '' });
  };

  markFieldValidate = formName => {
    const { dispatch, formStore } = this.props;

    if (formStore && formStore.registeredFields) {
      for (const field in formStore.registeredFields) {
        if (formStore.registeredFields.hasOwnProperty(field)) {
          if (formStore.registeredFields[field].count > 0) {
            dispatch(focus(formName, field));
            dispatch(touch(formName, field));
          }
        }
      }
    }
  };

  copyTemplate = async () => {
    this.setState({ loading: true });

    const { templateInfo: { attachInfoNo }, handleOnToggleModal, formStore } = this.props;

    let errorMessage = '';
    if (!formStore.syncErrors) {
      try {
        const params = {
          attachInfoNo: attachInfoNo,
          serviceNo: formStore.values.serviceNo,
          attachSubject: formStore.values.attachSubject
        };

        const { TemplateActions } = this.props;
        const response = await TemplateActions.copyAttach(params);
        if (response && !response.data.error) {
          TemplateActions.reloadAttach();
          handleOnToggleModal();
        } else if (!!response.data.error[0].errInfo) {
          // 서비스 넘버 에러
          if (response.data.error[0].errInfo === 'Invalid ServiceNo') {
            errorMessage = response.data.error[0].errInfo;
          }
        }
      } catch (e) {
        console.log(e);
        handleOnToggleModal();
      }
    } else {
      this.markFieldValidate('templateAttachCopy')
    }
    this.setState({ loading: false, errorMessage: errorMessage });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const { templateInfo: { attachInfoNo, attachSubject, regEpoch }, handleOnToggleModal } = this.props;
    const { onInitErrorMessage, copyTemplate } = this;
    const { loading, errorMessage } = this.state;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={'modal-admin tiny common-content'}
        closeIcon
        onToggleModal={handleOnToggleModal}
        visible
        header={
          <div>{defineMessages(formatMessage({ id: 'ExamAttachInTableMenu_3', defaultMessage: '첨부파일 복제' }))}</div>
        }
        buttons={
          <div className={'inline-block'}>
            <Btn buttonColor="#bbbbbb" onClick={handleOnToggleModal}>
              {defineMessages(formatMessage({ id: 'ExamTemplateCopy_2', defaultMessage: '취 소' }))}
            </Btn>
            <Btn className={'gray-button'} loading={loading} disabled={loading} onClick={copyTemplate}>
              {defineMessages(formatMessage({ id: 'ExamTemplateCopy_11', defaultMessage: '복 제' }))}
            </Btn>
          </div>
        }>
        <Loading
          active={loading}
          size="small"
          content={defineMessages(formatMessage({ id: 'ExamTemplateCopy_4', defaultMessage: '복제중...' }))}
        />
        <div className={'message-header'}>
          {defineMessages(
            formatMessage({
              id: 'ExamAttachCopy_1',
              defaultMessage: '첨부파일을 복제하여 새로 생성합니다.'
            })
          )}
          <br />
          {defineMessages(
            formatMessage({
              id: 'ExamAttachCopy_2',
              defaultMessage: '다음 첨부파일을 복제합니까?'
            })
          )}
        </div>
        <Message className={'template-detail-box'}>
          <div className={'template-detail'}>
            <List bulleted className={'template-detail-list'}>
              <List.Item className={'template-detail-item'}>
                <div className={'template-detail-item-title'}>No</div>
                {attachInfoNo}
              </List.Item>
              <List.Item className={'template-detail-item'}>
                <div className={'template-detail-item-title'}>
                  {defineMessages(formatMessage({ id: 'ExamAttachDelete_3', defaultMessage: '제목' }))}
                </div>
                {attachSubject}
              </List.Item>
              <List.Item className={'template-detail-item'}>
                <div className={'template-detail-item-title'}>
                  {defineMessages(formatMessage({ id: 'ExamTemplateList_17', defaultMessage: '등록일시' }))}
                </div>
                {common.timeFormatFromUTCEpoch(regEpoch)}
              </List.Item>
            </List>

            <span className={'materialTextField-title'}>
              {defineMessages(
                formatMessage({
                  id: 'ExamAttachCopy_4',
                  defaultMessage: '첨부파일 제목'
                })
              )}
            </span>
            <div className={'pointing-right'}>
              <ReduxFormMaterialTextField
                required
                name="attachSubject"
                className={'input-gap flex-column input-area'}
                checkType={101}
                validate={['required']}
              />
            </div>

            <span className={'materialTextField-title'}>
              {defineMessages(
                formatMessage({
                  id: 'ExamAttachCopy_3',
                  defaultMessage: '대상 서비스 번호'
                })
              )}
            </span>
            <div className={'pointing-right'}>
              <ReduxFormMaterialTextField
                required
                error={!!errorMessage}
                name="serviceNo"
                className={'input-gap flex-column input-area'}
                checkType={101}
                validate={['required', 'number', 'maxNumber', 'space']}
                onKeyPress={onInitErrorMessage}
                serviceCheck={!!errorMessage && defineMessages(formatMessage({ id: 'LicenseEdit_50', defaultMessage: '잘못된 서비스 번호입니다.' }))}
              />
            </div>
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}

const mapStateToProps = state => {
  return {
    formStore: state.form['templateAttachCopy']
  }
};

const mapDispatchToProps = dispatch => ({
  TemplateActions: bindActionCreators(templateActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'templateAttachCopy',
    enableReinitialize: true,
    touchOnChange: true
  })(injectIntl(ExamAttachCopyModal)));



// WEBPACK FOOTER //
// ./src/script/components/examAttach/ExamAttachCopyModal.js